/*
 * @Description: 绩效审批详情
 * @Author: 杨志航
 * @Date: 2026-01-16 10:48:06
 */

import React, { useState, useEffect } from 'react'
import {
  Descriptions,
  Steps,
  Button,
  Modal,
  Input,
  Table,
  Icon,
  message,
  Spin,
  Tag,
  Tooltip,
} from 'antd'
import api from '@/api'
import { parseSearch, judgeCryptoParamsUrl } from '@/utils'

const DItem = Descriptions.Item
const { Step } = Steps
const { Column } = Table
let searchParams = {}

const Detail = (props) => {
  const { location, history } = props
  const [loading, setLoading] = useState(true)
  const [confirmLoading, setConfirmLoading] = useState(false)
  const [detail, setDetail] = useState({})
  const [statusList, setStatusList] = useState([])
  const [logConList, setLogConList] = useState([])
  const [buttonAuthList, setButtonAuthList] = useState([])
  const [monthList, setMonthList] = useState([])
  const [assessItemList, setAssessItemList] = useState([])
  const [auditModalVisible, setAuditModalVisible] = useState(false)
  const [auditStatus, setAuditStatus] = useState(0) // 0-通过，1-驳回
  const [remark, setRemark] = useState('')
  const [assessVisible, setAssessVisible] = useState(false)
  const search = parseSearch(location.search)

  useEffect(() => {
    if (judgeCryptoParamsUrl(search)) {
      if (search.auditType) {
        searchParams = {
          monthId: search.id,
          auditType: search.auditType
        }
      } else {
        searchParams = {
          id: search.id
        }
      }
      getDetail()
    } else {
      message.error('没有本页访问权限')
      setTimeout(() => {
        history.goBack()
      }, 1000)
    }
  }, [])

  //获取页面信息
  const getDetail = () => {
    setLoading(true)
    api.getApprovalDetail(searchParams).then(data => {
      if (search.msgId) {
        api.setMessageReaded({ ids: [search.msgId] })
      }
      setDetail(data)
      setStatusList(data.procedureStatusList) // 审批进度
      setLogConList(data.procedureLogList) // 审批记录
      setButtonAuthList(data.buttonAuthList) // 审批权限
      setMonthList(data.monthList)
      setAssessItemList(data.assessItemList)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const handleAudit = () => {
    setConfirmLoading(true)
    if (auditStatus === 1 && buttonAuthList.reject_msg_require && remark === '') {
      message.error('请输入驳回审批意见')
      setConfirmLoading(false)
      return
    }
    let params = {
      id: detail.id,
      type: auditStatus,
    }
    if (remark) {
      params.remark = remark
    }
    api.submitAchAudit(params).then(() => {
      message.success('审批完成')
      getDetail()
      setConfirmLoading(false)
      setAuditModalVisible(false)
    }).catch(() => setConfirmLoading(false))
  }

  const showAuditModal = status => {
    setAuditStatus(status)
    setAuditModalVisible(true)
  }

const targetCol = [{
    title: '绩效月份',
    width: 130,
    dataIndex: 'month',
    fixed: 'left',
    align: 'center',
  }, {
    title: '姓名',
    width: 80,
    dataIndex: 'staffName',
    fixed: 'left',
    align: 'center',
  }, { 
    title: '员工号', 
    dataIndex: 'staffNo',
  }, { 
    title: '职级', 
    dataIndex: 'jobPosition',
  }, { 
    title: '直接主管', 
    dataIndex: 'leaderName',
  }, { 
    title: '部门负责人', 
    dataIndex: 'departmentLeaderName',
  }, { 
    title: '所属事业群', 
    dataIndex: 'groupName',
  }, { 
    title: '所属部门', 
    dataIndex: 'departmentName',
  }, {
    title: '考核项',
    render: (text, record) => (
      <>
        {record.targetList.map((item, index) => (
          <Tooltip title={item.assessItemDesc} key={index}>
            <div dangerouslySetInnerHTML={{ __html: item.assessItems }}></div>
          </Tooltip>
        ))}
      </>
    )
  }, {
    title: '考核权重',
    render: (text, record) => (
      <>
        {record.targetList.map((item, index) => (
          <div key={index} dangerouslySetInnerHTML={{ __html: item.weight }}></div>
        ))}
      </>
    )
  }, {
    title: '考核目标',
    render: (text, record) => (
      <>
        {record.targetList.map((item, index) => (
          <div key={index} dangerouslySetInnerHTML={{ __html: item.target }}></div>
        ))}
      </>
    )
  }]

  const resultCol = targetCol.concat([{
    title: '完成结果',
    render: (text, record) => (
      <>
        {record.targetList.map((item, index) => (
          <div key={index}>{item.result}</div>
        ))}
      </>
    )
  }, {
    title: '完成率',
    render: (text, record) => (
      <>
        {record.targetList.map((item, index) => (
          <div key={index}>{item.completionRate}</div>
        ))}
      </>
    )
  }, {
    title: '完成得分',
    render: (text, record) => (
      <>
        {record.targetList.map((item, index) => (
          <div key={index}>{item.assessResult}</div>
        ))}
      </>
    )
  }, {
    title: '绩效结果',
    dataIndex: 'assessResult',
  }])

  const assessCol = [{ 
    title: '考核项', 
    dataIndex: 'assessItems',
    width: 500,
    align: 'center',
    render: (text, record) => (
      <Tooltip title={record.assessItemDesc}>
        <span>{text}</span>
      </Tooltip>
    )
  }, { 
    title: '涉及人数', 
    dataIndex: 'num',
    align: 'center',
  }, { 
    title: '考核目标汇总', 
    dataIndex: 'target',
    align: 'center',
  }, { 
    title: '完成结果汇总', 
    dataIndex: 'result',
    align: 'center',
    reander: text => text || '-'
  }, { 
    title: '整体完成比率', 
    dataIndex: 'completionRate',
    align: 'center',
    reander: text => text || '-'
  }]

  return (
    <Spin spinning={loading}>
      <div className="pro-detail">
        <Button 
          type="primary"
          onClick={() => history.goBack()}  
          style={{ position: 'absolute', right: '20px', top: '-20px' }}
        >返回上一页</Button>
        <Descriptions title="审批详情" layout="horizontal " className="pro-detail-title">
          <DItem label="当前状态"><Tag color="#108ee9">{detail.auditStatusName}</Tag></DItem>
          <DItem label="绩效审批业务编号">{detail.businessNo}</DItem>
        </Descriptions>
        <Descriptions title="当前审批进度" className="pro-detail-smailtitle"></Descriptions>
        <div className="promotionProcess" >
          <Steps>
            {
              statusList.map((item, index) => {
                let status = 'wait'
                if (item.time && item.time.length > 1) {
                  status = 'process'
                }
                return <Step status={status}
                  key={index}
                  value={item.time}
                  title={item.nodeName}
                  description={
                    <>
                      {item.persons && <div title={`${item.persons.map((item) => item)}`}>{`${item.persons.map((item) => item)}`}</div>}
                      <div title={item.statusName}>{item.statusName}</div>
                      <div title={item.time}>{item.time}</div>
                    </>
                  }
                />
              })
            }
          </Steps>
        </div>
        <div className="line-box"></div>
        <Descriptions 
          title={`员工绩效${detail.auditType === 1 ? '目标' : '结果'} （人数：${monthList.length}）`}
          className="pro-detail-smailtitle"
        >
        </Descriptions>
        <Table 
          rowKey="id"
          columns={detail.auditType === 1 ? targetCol : resultCol} 
          dataSource={monthList} 
          scroll={{ x: 'max-content' }}
          pagination={false}
          style={{ marginBottom: '30px' }}
        />
        <div className="line-box"></div>
        <Descriptions 
          title={
            <div style={{ cursor: 'pointer' }} onClick={() => setAssessVisible(!assessVisible)}>
              <Icon type={assessVisible ? 'minus-square' : 'plus-square'} /> 考核项数据汇总
            </div>
          }
          className="pro-detail-smailtitle"
        >
        </Descriptions>
        {assessVisible && (
          <Table 
            rowKey={(record, i) => i}
            columns={assessCol} 
            dataSource={assessItemList} 
            pagination={false}
            size="small"
            style={{ marginBottom: '30px' }}
          />
        )}
        <div className="line-box"></div>
        <Descriptions
          title="审批记录"
          className="pro-detail-smailtitle"
        >
        </Descriptions>
        <Table
          dataSource={logConList}
          rowKey="id"
          pagination={false}
        >
          <Column title="姓名" dataIndex="userInfo.staffName" />
          <Column title="时间" dataIndex="addTime" />
          <Column title="状态" dataIndex="status" />
          <Column title="审批意见" dataIndex="chargeMsg" />
        </Table>
        {buttonAuthList.hasChargerPower && (
          <div style={{ display: 'flex', justifyContent: 'center', paddingTop: '40px' }}>
            <Button onClick={() => showAuditModal(1)} style={{ marginRight: '15px' }}>驳回</Button>
            <Button type="primary" onClick={() => showAuditModal(0)}>通过</Button>
          </div>
        )}
        <Modal
          title={auditStatus === 0 ? (
            <>确认通过 <Icon type="check-circle" theme="twoTone" twoToneColor="#52c41a" /></>
          ) : (
            <>确认驳回 <Icon type="close-circle" theme="twoTone" twoToneColor="#DC143C" /></>
          )}
          visible={auditModalVisible}
          onOk={handleAudit}
          onCancel={() => setAuditModalVisible(false)}
          confirmLoading={confirmLoading}
        >
          <div>
            <span>审批意见:</span>
            <Input.TextArea 
              placeholder="请输入审批意见" 
              value={remark} 
              onChange={evt => setRemark(evt.target.value.trim())} 
              maxLength={100} 
            />
          </div>
        </Modal>
      </div>
    </Spin>
  )
}

export default Detail
